import { number } from "./../types/number";

export default function multiply(a, b) {
  a = number(a);
  b = number(b);
  return a * b;
}
